<div class='verification-step'>
	<div class='only-inner-container'>
		<div class='inner-content'>

			<div class="quote-success">
				<div class="quote-success-content">
					<mat-icon svgIcon="icons:check"></mat-icon>
					<p i18n>Your quote request has been sent</p>
				</div>
			</div>

			<div class='title' i18n>Verify your phone number</div>

			<div class="subtitle">
				<div class="subtitle-content">
					<mat-icon svgIcon="icons:check"></mat-icon>
					<p i18n>Moving companies respond faster to verified users</p>
				</div>
			</div>

			<div class='confirmation-text' i18n>We've sent a 6-digit code to the number below</div>
			<div class='phone-display'>
				<input class='phone-input'
				       type='text'
				       [value]='phoneNumber'
				       readonly>
				<button class='phone-edit-btn' type='button' (click)='openChangePhoneModal()'>
					<mat-icon svgIcon='icons:pencil'></mat-icon>
				</button>
			</div>
			<form class='verification-form' [formGroup]='verificationForm' (ngSubmit)='onVerifySubmit()'>
				<div class='verification-code'>
					<input class='verification-hidden'
					       formControlName='otp'
					       name='otp'
					       type='hidden'>
					<div [formGroup]='codeForm'>
						<div class='verification-inputs' formArrayName='digits' (paste)='onCodePaste( $event )'>
							<input *ngFor='let _ of codeLengthArray; let index = index'
							       #codeInput
							       class='verification-input'
							       [class.invalid]='isInputInvalid( index )'
							       [class.has-value]='hasDigitValue( index )'
							       type='text'
							       inputmode='numeric'
							       autocomplete='one-time-code'
							       [attr.maxLength]='1'
							       [formControlName]='index'
							       (input)='onCodeInput( index, $event )'
							       (keydown)='onCodeKeydown( index, $event )'
							       (focus)='onCodeFocus( $event )'
							       [attr.aria-label]="'Verification digit ' + ( index + 1 )">
						</div>
					</div>
				</div>
				<p class='verification-error' *ngIf='verifyCooldownRemaining > 0' i18n>Too many attempts. Please try again in {{ verifyCooldownRemaining }} seconds.</p>
				<p class='verification-error' *ngIf='verifyCooldownRemaining === 0 && verifyError'>{{ verifyError }}</p>
				<div class='resend-code-wrap'>
					<button type='button'
					        class='resend-code'
					        [disabled]='!resendAllowed'
					        (click)='onResendCode()'>
						<ng-container *ngIf='resendLoading' i18n>Sending…</ng-container>
						<ng-container *ngIf='!resendLoading && resendCooldownRemaining === 0' i18n>Resend code</ng-container>
						<ng-container *ngIf='!resendLoading && resendCooldownRemaining > 0'>
							<span i18n>Resend code in ({{ resendCooldownRemaining }}s)</span>
						</ng-container>
					</button>
				</div>

				<div class='form-button'>
					<button class='submit-verify' type='submit' [disabled]='!verifyAllowed'>
						<ng-container *ngIf='!verifyLoading && verifyCooldownRemaining === 0' i18n>Verify</ng-container>
						<ng-container *ngIf='verifyLoading' i18n>Verifying…</ng-container>
						<ng-container *ngIf='!verifyLoading && verifyCooldownRemaining > 0'>
							<span i18n>Verify ({{ verifyCooldownRemaining }}s)</span>
						</ng-container>
					</button>
					<div class='or-divider'>
						<span i18n>or</span>
					</div>
					<a class='skip-verify' (click)='onVerifySkip()' i18n>Continue without verifying</a>
				</div>
		
			</form>
		</div>
	</div>
</div>
